import { createStore, applyMiddleware, type Store } from 'redux';
import { createEpicMiddleware } from 'redux-observable';
import composeWithDevtools from '@atlassian/jira-common-util-compose-with-devtools';
import type { State } from '../../types';
import createEpics from '../project-access-root-epic';
import rootReducer from '../project-access-root-reducer';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (initialState: State): Store<State> =>
	createStore(
		rootReducer,
		initialState,
		composeWithDevtools({ name: 'Project Access' })(
			applyMiddleware(createEpicMiddleware(createEpics)),
		),
	);
